import React, { Component } from "react";
import { Tabs } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { Col, CardBody } from "reactstrap";
import { Card } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Button } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import GeoCoding from "../transaction/order/GeoCoding";
import AddressZone from "../Zone_Management/zone/AddressZone";
import SimpleReactValidator from 'simple-react-validator';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Create';
//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dateFormat from 'dateformat';
import { connect } from "react-redux";
import 'moment/locale/fr.js' // or 'rc-datepicker/node_modules/moment/locale/fr.js' if you don't have it in your node_modules folder
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import moment from "moment";
import { toast } from 'react-toastify';
import { logincheck } from '../Userlogin/Userlogin'

class CustomerDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            customerData: "", userData: "", associateId: "", Data: [], toggleAddress: false, toggleCheckAddress: false, address: ""
            , label: "", zoneFlag: false, disableSubmit: false, lat: "", lng: "", zone: "", addressId: "",
            customerId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,
            fromDate: "", toDate: "", fromDate1: "", toDate1: "", pricePerKL: "", selectDate: "", selectDate1: "", ptds: "",showtocustomer: "No",
            editPrice: false, statusUpdate: false, contractPriceToDate: "", contractPriceFromDate: "", corporateRenewalStatus: "",validmap:"0", btnsb :'0',qrpath:""
       
        };
        this.nextPath = this.nextPath.bind(this);
        this.addressValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
        this.pdValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    }

    nextPath(path, value) {
        this.props.history.push({ pathname: path, data: value, state: { data: value } });
    }

    componentDidMount() {
		logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
			console.log(data.status_check)
			if(data.status_check === 0) {
				this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
			}
		})
        const url = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/getCCbyId/" + this.state.customerId
        fetch(url,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              }
        }).then(
            response => { return response.json(); }
        ).then(data => {
           console.log(data[0])
            this.setState({ customerData: data[0], userData: data[0].user  }, () => this.getAllAddress(data[0].corporateId))
            this.setState({ qrpath:"http://gowatr.com/qrcode/images/"+data[0].corporateId+'.png' });
        })
    }

    // fetchContractPrice = (Id) => {
    //     const url5 = "/api/contractPrice/getCPbyAssociateId/" + Id
    //     fetch(url5).then(
    //         response => {
    //             if (!response.ok) throw new Error(response.status);
    //             else return response.json();
    //         }
    //     ).then(data => {
    //         console.log(data)
    //         this.setState({
    //             fromDate: dateFormat(data[0].fromDate, "dd-mm-yyyy"), contractPriceFromDate: data[0].fromDate,
    //             toDate: dateFormat(data[0].toDate, "dd-mm-yyyy"), contractPriceToDate: data[0].toDate, pricePerKL: data[0].pricePerKL
    //         });
    //     }).catch(error => console.log(error), this.setState({ priceData: "" }))
    // }


    myCallback = (dataFromChild) => {
        this.setState({ lat: dataFromChild.lat, lng: dataFromChild.lng, address: dataFromChild.fullAddress })
    }

    getAllAddress(value) {
        this.setState({ associateId: value });
        const url5 = process.env.REACT_APP_NODE_ENV + "/api/address/getAddressbyCustomerId/" + value
        fetch(url5,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              }
        }).then(
            response => {
                if (!response.ok) throw new Error(response.status);
                else return response.json();
            }
        ).then(data => {
            this.setState({ Data: data });
        }).catch(error => console.log(error), this.setState({ Data: [] }))
    }

    newAddress1 = () => {
        this.setState({ toggleAddress: true })
    };

   newAddressClickEventHandler = () => {
		
       if(this.state.address === "") {
			this.addressValidator.showMessages();
            this.forceUpdate();
			
			this.setState({ toggleCheckAddress: false });
		} else {
			console.log(this.state.address,'check address')
			this.setState ({ btnsb : 0 })
			this.setState({ toggleCheckAddress: true, });
		}
    };

    myZoneCallback = (dataFromChild) => {
        this.setState({ zone: dataFromChild, zoneFlag: false });
        if (!this.state.zoneFlag) {
            this.addAddress();
        }
    }

    addAddress = () => {
        this.addNewAddress();
    }
    addNewAddress = () => {
        if (this.addressValidator.allValid()) {
            const { associateId, address, lat, lng, zone, label } = this.state;
			
			if(lat === "" && lng  === "") {
				
				this.setState ({ validmap : '1' })
				
			} else {
				this.setState ({ validmap : '0' })
            let postAddressData = {
                associateId: associateId, defaultAddress: "No",
                fullAddress: address, geolocationLat: lat, geolocationLng: lng, zone: zone, label: label
            };
            fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
                  },
                body: JSON.stringify(postAddressData)
            }).then(response => {
                response.json();
                if (response.status === 406) {
                    toast.error("Address already exist.", {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
            })
                .then((data) => {
                    this.addressValidator.hideMessages();
					 toast.success("Address created successfully.", {
                        position: toast.POSITION.TOP_CENTER,
                    })
                    this.setState({
                        address: "", lat: "", lng: "", zone: "", label: "",
                        toggleAddress: false,
                        toggleCheckAddress: false, zoneFlag: false, disableSubmit: false
                    }, () => this.componentDidMount())
                })
                .catch(error => console.log(error))
				
			}
        } else {
            this.addressValidator.showMessages();
            this.forceUpdate();
        }
    }

   newAddressHandler = event => {
        switch (event.target.id) {
            case "address":
                 this.setState({ address: event.target.value, toggleCheckAddress: false, btnsb : '0', validmap : '0',  }); break;
            case "adlabel":
                this.setState({ label: event.target.value }); break;
            default: break;
        }
    }

    toggleNewAddressModal = () => {
        this.setState({ disableSubmit: true }, () => this.addNewAddress());
    };

    toggleNewAddressModalCancel = () => {
        this.addressValidator.hideMessages();
        this.setState({ toggleAddress: false, toggleCheckAddress: false, address: "", label: "", validmap : "0", })
    }

    save = () => {
		
        if (this.pdValidator.allValid()) {
            let postOrderData = "";
            if (this.state.statusUpdate) {
                postOrderData = {
                    "CPfromDate": this.state.contractPriceFromDate,
                    "CPtoDate": this.state.contractPriceToDate,
                    "pricePerKL": this.state.pricePerKL, "corporateRenewalStatus": this.state.corporateRenewalStatus,
					"tds": this.state.ptds,
					"showtocustomer": this.state.showtocustomer,
                    "associateId": this.state.customerData.corporateId, "id": this.state.addressId
                }
                fetch(process.env.REACT_APP_NODE_ENV + '/api/address/updateAddresspricekl', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
                      },
                    body: JSON.stringify(postOrderData)
                }).then((res) => res.json())
                    .then((data) => {
						if(data.error_code === '1') {
							 
							toast.error(data.message, {
								position: toast.POSITION.TOP_CENTER,
								autoClose: 4000
								});
								this.setState({ contractPriceFromDate: "", contractPriceToDate: "", pricePerKL: "", ptds: "", editPrice: false })
							this.componentDidMount()
							
						}
						else {
							toast.success("Contact price updated successfully", {
								position: toast.POSITION.TOP_CENTER,
								autoClose: 3000
								});
							this.setState({ contractPriceFromDate: "", contractPriceToDate: "", pricePerKL: "", ptds: "", editPrice: false })
							this.componentDidMount()
						}
                        
                    })
                    .catch((err) => console.log(err))
            }
            else {
                this.pdValidator.showMessages();
            this.forceUpdate();
            }
        
		}
		else {
			this.pdValidator.showMessages();
            this.forceUpdate();
			
		}
    }

    popUpCancel = () => {
        this.setState({ editPrice: false, statusUpdate: false });
    }

    editPriceHandler = (value) => {
        const doesToggle = this.state.editPrice;
        this.setState({
            contractPriceFromDate: value.CPfromDate, contractPriceToDate: value.CPtoDate,
            pricePerKL: value.pricePerKL, ptds:value.tds, showtocustomer: value.showtocustomer, addressId: value.id, editPrice: !doesToggle, corporateRenewalStatus: "RENEWED"
        });
    };

    handleChange2 = date => {
        this.setState({ contractPriceFromDate: date, statusUpdate: true });
    };

    handleChange3 = date => {
        this.setState({ contractPriceToDate: date, statusUpdate: true });
    };

    handleUserFormFields = event => {
        this.pdValidator.showMessageFor(event.target.name)
        switch (event.target.id) {
            case "pdFromDate":
                this.setState({ fromDate: event.target.value, statusUpdate: true });
                break;
            case "pdToDate":
                this.setState({ toDate: event.target.value, statusUpdate: true });
                break;
            case "pdPricePerKL":
                this.setState({ pricePerKL: event.target.value, statusUpdate: true });
                break;
			case "ptds":
                this.setState({ ptds: event.target.value, statusUpdate: true });
                break;
			case "showtocustomer":
                this.setState({ showtocustomer: event.target.value, statusUpdate: true });
                break;
            default:
                break;
        }
    };

    render() {

        const dataArr = [];
        this.state.Data.map((data) => {
            let cpFromDate = "", cpToDate = ""
            if (data.CPfromDate === null) cpFromDate = ""
            else cpFromDate = dateFormat(data.CPfromDate, "dd-mm-yyyy")
            if (data.CPtoDate === null) cpToDate = ""
            else cpToDate = dateFormat(data.CPtoDate, "dd-mm-yyyy")
			
			let defaultadd="No"
			if (data.defaultAddress === "Yes") { defaultadd = "Yes" }
			
			if(data.CPtoDate)
			{
				var expire = "Active";
				var now = new Date();
				
				var order_date = new Date(dateFormat(data.CPtoDate, "yyyy-mm-dd"));
				var start_date = new Date(dateFormat(now, "yyyy-mm-dd"));					
				
				if(+start_date > +order_date)
				{
					expire = "Expired";
				}
				
			}else{
				expire = "In-Review";
			}
			
            let mdData = [
                data.label, data.fullAddress, defaultadd, data.tds, data.showtocustomer, cpFromDate, cpToDate, expire, data.pricePerKL, data
            ]
            dataArr.push(mdData)

            return null;
        });
        const columns = [
            {
                name: "title",
                label: "Title",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "address",
                label: "Address",
                options: {
                    filter: true,
                    sort: true,
                }
            },
			{
                name: "DefaultAddress",
                label: "Default Address",
                options: {
                    filter: true,
                    sort: true,
                }
            },
			{
                name: "tds",
                label: "TDS",
                options: {
                    filter: true,
                    sort: true,
                }
            },
			{
                name: "showtocustomer",
                label: "Show To Customer",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpFromDate",
                label: "CP From Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpToDate",
                label: "CP To Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "expire",
                label: "Status",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "pricePerKL",
                label: "Price Per KL",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "actions",
                label: "Actions",
                options: {
                    filter: false,
                    sort: false,
					download: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <Tooltip title="Edit"><IconButton><EditIcon onClick={() => this.editPriceHandler(value)} />
                            </IconButton></Tooltip>
                        );
                    }
                }
            }
        ];

        const columns1 = [
            {
                name: "title",
                label: "Title",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "address",
                label: "Address",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpFromDate",
                label: "CP From Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpToDate",
                label: "CP To Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "pricePerKL",
                label: "Price Per KL",
                options: {
                    filter: true,
                    sort: true,
                }
            }
        ];


        const options = {
            filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none",
            // onRowsDelete: (rowsDeleted) => {
            //     for (var key in rowsDeleted.data) {
            //         this.delete(dataArr[rowsDeleted.data[key].index].id)
            //     }
            // }
        };

        let newAddress = null;
        if (this.state.toggleAddress) {
            newAddress = (
              <div>
                    <Modal isOpen={true}
                        style={{ width: "1200px", display: "block" }}
                    >
                        <Card style={{ width: "50rem" }}>
                            <CardBody>
                                <ModalHeader>New Address</ModalHeader>
                                <ModalBody>
                                    <Form>
                                        <Form.Row>
                                            <Col>
												<Form.Group controlId="adlabel">
                                                    <Form.Control placeholder="Title"
                                                        value={this.state.label}
                                                        onChange={this.newAddressHandler}
                                                    ></Form.Control>
                                                    {this.addressValidator.message('Title', this.state.label, 'required')}
                                                </Form.Group>
                                                
                                            </Col>
                                        </Form.Row>
                                        <Form.Row>
                                            <Col>
												<Form.Group controlId="address">
                                                    <Form.Control placeholder="address"
                                                        value={this.state.address}
                                                        onChange={this.newAddressHandler}
                                                    ></Form.Control>
                                                    {this.addressValidator.message('Address', this.state.address, 'required')}
                                                </Form.Group>
                                                
                                            </Col>
                                        </Form.Row>

                                    </Form>
                                    <Button
                                        style={{ marginTop: "10px" }}
                                        onClick={this.newAddressClickEventHandler}
                                        variant="outline-success" >
                                        Check  </Button>&nbsp;&nbsp;&nbsp;{  this.state.validmap === '1' &&  <div class="text-danger">Invalid Address, Please check again</div>  }

                                    {this.state.toggleCheckAddress ? (
                                        <div className="col-md-12" style={{ marginTop: "10px" }} >
                                            {navigator.onLine ? <GeoCoding address={this.state.address} callbackFromParent={this.myCallback} /> : "You Are Not Connected To Internet"}
                                        </div>
                                    ) : null}
                                </ModalBody>
                                <ModalFooter>
                                   {this.state.btnsb === 0 &&  <Button variant="outline-success" disabled={this.disableSubmit}
                                        onClick={this.toggleNewAddressModal} >
                                        Submit
								</Button> }
							{this.state.btnsb === 1 &&  <Button variant="outline-success" disabled={this.disableSubmit}
                                        onClick={this.toggleNewAddressModal} >
                                        Submit
								</Button> }	&nbsp;&nbsp;&nbsp;
                                    <Button variant="outline-success"
                                        onClick={this.toggleNewAddressModalCancel} >
                                        Cancel
                      </Button>
                                </ModalFooter>
                            </CardBody>
                        </Card>
                    </Modal>
                </div>
            );
        }

        let zone = null;

        if (this.state.lat !== 0 && this.state.lng !== 0) {

            if (this.state.zoneFlag) {
                zone = (<AddressZone lat={this.state.lng} lng={this.state.lat} callbackFromZone={this.myZoneCallback}></AddressZone>)
            }

        }

        let statusEdit = (<form>
            <div className="kt-heading kt-heading--md">Contract Details</div>
            <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v1__form">
                    <div className="row">
                        <div className="col-lg-5">
                            <label><b>From</b></label>
                            <DatePickerInput locale='en' className='my-custom-datepicker-component'
                                displayFormat="DD-MM-YYYY"
								name="FromDate"
								readOnly={true}
								 maxDate={this.state.contractPriceToDate}
                                minDate={this.state.contractPriceToDate}
                                value={this.state.contractPriceFromDate}
                                selected={this.state.contractPriceFromDate ? moment(this.state.contractPriceFromDate) : null}
                                onChange={this.handleChange2} />
								{
                                    this.pdValidator.message('FromDate', this.state.contractPriceFromDate, 'required')
                                }
                            {/* {
                        this.state.fcDueByRequired &&
                        <span className="form-text text-muted">Please enter your FC Due By.</span>
                      } */}
                        </div>
                        <div className="col-lg-2">
                        </div>
                        <div className="col-lg-5">
                            <label><b>To</b></label>
                            <DatePickerInput locale='en' className='my-custom-datepicker-component' name="to date"
                                displayFormat="DD-MM-YYYY" minDate={this.state.contractPriceFromDate} disabled={this.state.contractPriceFromDate === null ? true : false}
								minDate={this.state.contractPriceFromDate}
								readOnly={true}
                                value={this.state.contractPriceToDate}
                                selected={this.state.contractPriceToDate ? moment(this.state.contractPriceToDate) : null}
                                onChange={this.handleChange3} />
								{
                                    this.pdValidator.message('to date', this.state.contractPriceToDate, 'required')
                                }
                            {/* {
								
                        this.state.fcDueByRequired &&
                        <span className="form-text text-muted">Please enter your FC Due By.</span>
                      } */}
                        </div>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-lg-5">
							<div className="form-group">
								<label><b>TDS</b></label>
								<select name="Total Dissolved Solids" className="form-control" id="ptds" value={this.state.ptds} onChange={this.handleUserFormFields} style={{ fontWeight: 'bold' }} >
									<option value=""> Please Select </option>
									<option value="less than 300(Excellent)"> less than 300(Excellent) </option>
									<option value="300-600(Good)"> 300-500(Good) </option>
									<option value="600-900(Fair)"> 600-900(Fair) </option>
									<option value="900-1200(Poor)"> 900-1200(Poor)</option>
									<option value="Above 1200(Unacceptable)"> Above 1200(Unacceptable) </option>
								</select>
                                {
                                    this.pdValidator.message('TDS', this.state.ptds, 'required')
                                }
							</div>
                        </div>
						<div className="col-lg-2">
                        </div>
                        <div className="col-lg-5">
                            <div className="form-group">
                                <label><b>Price per KL</b></label>
                                <input type="text" className="form-control" id="pdPricePerKL" name='Price per KL' placeholder="Price per KL" value={this.state.pricePerKL} onChange={this.handleUserFormFields} style={{ fontWeight: 'bold' }} />
                                {
                                    this.pdValidator.message('Price per kl', this.state.pricePerKL, 'required|integer')
                                }
                            </div></div>
                    </div>
					<div className="row">
                        <div className="col-lg-5">
							 <div className="form-group">
								<label><b>Show to Customer?</b></label>
								<select name="showtocustomer" className="form-control" id="showtocustomer" value={this.state.showtocustomer} onChange={this.handleUserFormFields} style={{ fontWeight: 'bold' }} >
									<option value="">Please Select</option>
									<option value="No">No</option>
									<option value="Yes">Yes</option>
								</select>
                                {
                                    this.pdValidator.message('Show To Customer', this.state.showtocustomer, 'required')
                                }
							</div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        )

        let editStatuss = null;
        if (this.state.editPrice) {
            editStatuss = (
                <Modal
                    isOpen={true}
                    // fade={false}
                    // toggle={this.to}
                    style={{ width: "1200px", display: "block" }}
                >
                    <Card style={{ width: "50rem" }}>
                        <CardBody>
                            <ModalHeader>Edit Contract Details for - {this.state.customerData.companyName}</ModalHeader>
                            <ModalBody>
                                {statusEdit}
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="outline-primary" onClick={() => this.save()}>
                                    Save
                  </Button>&nbsp;&nbsp;&nbsp;
                                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
                            </ModalFooter>
                        </CardBody>
                    </Card>
                </Modal>
            );
        }

        let showUpdateBtton = "";
        let showDeliveryAdderss = "";
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE') {
            // showUpdateBtton = <Button className="float-right"
            //     variant="outline-success"
            //     style={{ marginTop: "25px", width: "200px" }}
            //     onClick={() => this.editPriceHandler()}>
            //     Update Contract Info
            //     </Button>;
            showDeliveryAdderss = <Tab eventKey="deliveryAddress" title="Delivery Address">
                <div>
                    <Button className="float-right"
                        variant="outline-success"
                        style={{ marginTop: "10px", width: "150px", marginRight: "25px" }}
                        onClick={() => this.newAddress1()}>
                        Add Address
</Button></div>
                {newAddress}
                {zone}
                <div>
                    <MUIDataTable
                        title={"Delivery Address List"}
                        data={dataArr}
                        columns={columns}
                        options={options} />
                </div>
            </Tab>;
        }

        let contractPriceTab = ""
        if (this.props.userRole === "Corporate Customer") {
            contractPriceTab = (<Tab eventKey="contractPricing" title="Contract Pricing">
                {showUpdateBtton}
                <MUIDataTable
                    data={dataArr}
                    columns={columns1}
                    options={options} />
            </Tab>)
        }

        let breadCrumbForUser = ""
        let vipCustomerTab = ""
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User"  || this.props.userRole =='CRE') {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item
                    onClick={() => this.nextPath("/corp-customer/customer-list")}
                >
                    Customer List
          </Breadcrumb.Item>

                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
            // vipCustomerTab = (<Form.Group className="col-lg-4" as={Col}>
            //     <Form.Label>VIP Customer:</Form.Label>
            //     <Form.Control
            //         type="text"
            //         value={this.state.customerData.vipCustomer === 'YES' ? 'Yes' : 'No'}
            //     ></Form.Control>
            // </Form.Group>)
        } else {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>
            )
        }

        return (<>
            {breadCrumbForUser}
            {editStatuss}

            <div>
                <Card>
                    <Card.Body>
                        <Card.Title style={{ fontWeight: "bold", fontSize: "20px" }}>
							<div className="row">
								<div className="col-lg-8">
								
									{!this.state.customerData.profileimageurl ?  (<>Customer Details -  {this.state.userData.usercompanyName} ({this.state.customerData.corporateId}) </> ) :  (<>
									  <img src={this.state.customerData.profileimageurl} class="rounded-circle" alt="profile Image" width="100" height="100" /><br /><br />{this.state.userData.usercompanyName} ({this.state.customerData.corporateId}) 
									  </>)
									}
								</div>
								<div className="col-lg-4">
									 <Button className="float-right"
                                variant="outline-success"
                                style={{ marginTop: "25px", width: "150px" }}
                                onClick={() => this.nextPath("/corp-customer/customer-edit", this.state.customerId)}>
                                Edit
                  </Button>
								</div>
							</div>
                           
                           
                        </Card.Title>

                        <br />
                        <br />
                        <Tabs defaultActiveKey="basic-details">
                            <Tab eventKey="basic-details" title="Company Details">
							  <div className="kt-heading kt-heading--md">Basic Details</div>
                                    <div className="col-lg-12">
                                        <img src={this.state.qrpath} onError={(e)=>{e.target.onerror = null; e.target.src="http://gowatr.com/qrcode/images/blocked.png"}} class="d-block mx-auto img-fluid" alt="profile Image" width="350px" /> 		
								    </div>
                                <Form>
                                    <Form.Row>
									<Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Company Name:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.userData.usercompanyName } disabled
                                            ></Form.Control>
                                        </Form.Group>
									<Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Email :</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.userData.userEmail} disabled
                                            ></Form.Control>
                                        </Form.Group>
										<Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Phone Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.userData.userPhoneNumber} disabled
                                            ></Form.Control>
                                        </Form.Group>
										<Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> First Name:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.userData.userFirstName} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Last Name:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.userData.userLastName} disabled
                                            ></Form.Control>
                                        </Form.Group>
										<Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Email:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.email} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Contact Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.contactNumber} disabled
                                            ></Form.Control>
                                        </Form.Group>
										<Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Alternate Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.alternateNumber } disabled
                                            ></Form.Control>
                                        </Form.Group>
										<Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Contract Document Url: <br /></Form.Label>
											<div className="form-control">
                                            {!this.state.customerData.contractdocumenturl ? (<>
									 <a href={this.state.customerData.contractdocumenturl}  target="_Blank" download>View document</a><br /><br />
									  </>)   :  (<>
									   <a href={this.state.customerData.contractdocumenturl}  target="_Blank" download>View document</a><br /><br />
									  </>)
									  
								}
								</div>
                                        </Form.Group>
									</Form.Row>
									 
							<div className="kt-heading kt-heading--md">Company Details</div>
                                    <Form.Row>
									    <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Company Type:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.companyType} disabled
                                            ></Form.Control>
                                        </Form.Group>
										 <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Sump/Tank Capacity:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.tankCapacity} disabled
                                            ></Form.Control>
                                        </Form.Group>
										 <Form.Group as={Col} className="col-lg-4" >
                                            <Form.Label> Daily Need(in kl):</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.dailyNeed} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label>Road Size (in ft):</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.roadSize} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Distance Between Gate & Sump (in ft):</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.distanceBetweenGateAndSump} disabled
                                            ></Form.Control>
                                        </Form.Group>
										 <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label>Preferred TDS:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.totalDissolvedSolids} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>

                                </Form>
                            </Tab>

                            <Tab eventKey="business" title="Business">
                                <Form>
									 <div className="kt-heading kt-heading--md">Business Details</div>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label> GST Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.gstNumber} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label> PAN Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.panNumber} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        {vipCustomerTab}

                                        {/* <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label> Contact Person 2:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.pocName2} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label>Phone Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.pocphoneNumber2} disabled
                                            ></Form.Control>
                                        </Form.Group> */}
                                    </Form.Row>
                                </Form>
                            </Tab>
							<Tab eventKey="address" title="Address">
                                <Form>
								  <div className="kt-heading kt-heading--md">Address Details</div>
                                    <Form.Row>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Door Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.doorNumber} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Street Name:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.streetName
                                                } disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Area:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.area} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label> City:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.city} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label> Landmark</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.landmark} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label> Pincode:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.pincode} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>
                            {showDeliveryAdderss}
                            {contractPriceTab}
                        </Tabs>
                    </Card.Body>
                </Card>
            </div>
        </>
        );
    }
}

const mapStateToProps = (state /*, ownProps*/) => {
    return {
        userRole: state.auth.user[0].userType,
        userId: state.auth.user[0].id,
		mobiledevice: state.auth.user[0].mobiledeviceId,
    }
}

export default connect(
    mapStateToProps,
    null
)(CustomerDetails)